export function toBackendPricePerArea(value: unknown): number | undefined {
	const numericValue = Number(value);
	if (!Number.isFinite(numericValue) || numericValue <= 0) {
		return undefined;
	}
	return Math.round(numericValue);
}

export function calculatePriceRemont(params: {
	area: unknown;
	finishedPrice: unknown;
	pricePerArea: unknown;
}): number {
	const area = Number(params.area);
	const finishedPrice = Number(params.finishedPrice);
	const pricePerArea = Number(params.pricePerArea);
	const hasValidInputs =
		Number.isFinite(area) && Number.isFinite(finishedPrice) && Number.isFinite(pricePerArea);

	if (!hasValidInputs) {
		return 0;
	}

	const baseTotalPrice = pricePerArea * area;
	return finishedPrice > baseTotalPrice ? Math.round(finishedPrice - baseTotalPrice) : 0;
}
